import React, { Component } from 'react';
import './index.css';
import Overview from './Overview';
import WidgetValues from './WidgetValues';
import AppActions from './AppActions';
import Connections from './Connections';
import Logic from './Logic';
import Loops from './Loops';
import MathSection from './Math';
import Text from './Text';
import Lists from './Lists';
import Colours from './Colours';
import Dates from './Dates';
import Variables from './Variables';
import XSightTopics from './XSightTopics';
import Table from './Table';
import MobiControl from './Mobicontrol';
import DebugTools from './DebugTools';
import CodeBlocks from './CodeBlocks';
import Sounds from './Sounds';
import Repeater from './Repeater';
export default class Documentation extends Component {
    render() {
        return (
            <div id={"documentation"}>

                <h2 id={'title'}>SOTI Blockly Documentation</h2>
                <div id={'content'}>
                    <div id={'contents'}>

                        <ul id={'left-menu'}>
                            <h3>Contents</h3>
                            <li><a href="#overview">Overview</a></li>
                            <li><a href="#widget-values">Widget Values</a></li>
                            <li><a href="#app-actions">App Actions</a></li>
                            <li><a href="#connections">Connections</a></li>
                            <li><a href="#code-blocks">Code Blocks</a></li>
                            <li><a href="#XSight Topics">XSight Topics</a></li>
                            <li><a href="#variables">Local and Global Variables</a></li>
                            <li><a href="#logic">Logic</a></li>
                            <li><a href="#loops">Loops</a></li>
                            <li><a href="#math">Math</a></li>
                            <li><a href="#text">Text</a></li>
                            <li><a href="#lists">Lists</a></li>
                            <li><a href="#colours">Colours</a></li>
                            <li><a href="#dates_section">Dates</a></li>
                            <li><a href="#Table">Table</a></li>
                            <li><a href="#Sounds">Sounds</a></li>
                            <li><a href="#repeater">Repeater</a></li>
                            <li><a href="#mobicontrol">MobiControl</a></li>
                            <li><a href="#debug-tools">Debug Tools</a></li>

                        </ul>
                    </div>
                    <div id={'material'}>
                        <div className={"documentation-container"}>

                            <Overview />

                            <WidgetValues />

                            <AppActions />

                            <Connections />

                            <CodeBlocks />

                            <XSightTopics />

                            <Variables />

                            <Logic />

                            <Loops />

                            <MathSection />

                            <Text />

                            <Lists />

                            <Colours />

                            <Dates />

                            <Table />

                            <Sounds />

                            <Repeater />

                            <MobiControl />

                            <DebugTools />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

